import { render } from "./Startup.vue?vue&type=template&id=8a489136"
import script from "./Startup.vue?vue&type=script&lang=js"
export * from "./Startup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__